import { useMemo } from "react";

import { useSelector } from "react-redux";

import { EMPTY_ARRAY } from "app/pages/sales-intelligence/constants/common";
import { useSignalNamesById } from "app/pages/sales-intelligence/sub-modules/signals/hooks/useUISignals";
import signalsService from "app/pages/sales-intelligence/sub-modules/signals/services/signalsService";

import { selectContextualSuggestionsData } from "../store/selectors";

export function useContextualSuggestionsList(): readonly string[] {
    const data = useSelector(selectContextualSuggestionsData);

    const signalNamesGroupedById = useSignalNamesById();

    return useMemo(() => {
        if (!data) {
            return EMPTY_ARRAY;
        }

        const signalIds = data.SignalsToAdd ?? EMPTY_ARRAY;
        const filtersToAdd = data.FiltersToAdd ?? EMPTY_ARRAY;

        const signalNames =
            signalIds.length > 0
                ? signalIds
                      .map((id) => signalNamesGroupedById[id])
                      .filter(Boolean)
                      .map(signalsService.sanitizeSignalName)
                : [];

        return [...signalNames, ...filtersToAdd];
    }, [data, signalNamesGroupedById]);
}
